import {
  getFloat,
  getObject,
  getOptionalObject,
} from "@surya-digital/leo-ts-types";
import { QuartileColorWithHexCodes, QuartileColorWithHexCodesDTO } from "./quartileColorWithHexCodes";


export namespace ProportionChartType {
  export interface RygDTO {
    case: string;
    mean: number;
    quartileColor?: QuartileColorWithHexCodesDTO | null;
  }
  
  export class Ryg {
    readonly isProportionChartTypeRyg: boolean = true;
  
    readonly mean: number;
    readonly quartileColor: QuartileColorWithHexCodes | null;
  
  
    constructor(
    mean: number, 
    quartileColor: QuartileColorWithHexCodes | null = null
    ) {
      this.mean = mean;
      this.quartileColor = quartileColor;
    }
  
    static fromDTO(dto: RygDTO): Ryg {
      const mean = getFloat(dto, "mean", InvalidProportionChartTypeRygMeanError);
      let quartileColor = getOptionalObject(dto, "quartileColor");
      if(quartileColor !== undefined && quartileColor !== null) {
        quartileColor = QuartileColorWithHexCodes.fromDTO(getObject(dto, "quartileColor", InvalidProportionChartTypeRygQuartileColorError));
      }
      return new Ryg(
        mean,
        quartileColor
      );
    }
  
    toDTO(): RygDTO {
      const dto: RygDTO = {
        case: "RYG",
          mean: this.mean,
      };
      if (this.quartileColor !== undefined && this.quartileColor !== null){
        dto.quartileColor = this.quartileColor.toDTO();
      }
      return dto;
    }
    }
  
  Ryg.prototype.toString = function toString(): string {
    return `ProportionChartType.RYG(mean='${this.mean}',quartileColor='${this.quartileColor}')`;
  };
  
  export interface NeutralDTO {
    case: string;
  }
  
  export class Neutral {
    readonly isProportionChartTypeNeutral: boolean = true;
  
  
  
  
  
    toDTO(): NeutralDTO {
      const dto: NeutralDTO = {
        case: "NEUTRAL",
      };
      return dto;
    }
    }
  
  Neutral.prototype.toString = function toString(): string {
    return `ProportionChartType.NEUTRAL()`;
  };
  

  export type ProportionChartType = Ryg | Neutral;

  export type ProportionChartTypeDTO = RygDTO | NeutralDTO;

  export const fromDTO = (dto: ProportionChartTypeDTO): ProportionChartType => {
    switch (dto.case) {
      case "RYG":
          return Ryg.fromDTO(dto as RygDTO);
      case "NEUTRAL":
          return new Neutral();
      default:
        throw new InvalidProportionChartTypeError(
            `Case ${dto.case} is not valid case of ProportionChartType.`
        );
    }
  };
}

export class InvalidProportionChartTypeError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidProportionChartTypeError";
  }
}
export class InvalidProportionChartTypeRygError extends InvalidProportionChartTypeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidProportionChartTypeRygError";
  }
}

export class InvalidProportionChartTypeRygMeanError extends InvalidProportionChartTypeRygError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidProportionChartTypeRygMeanError";
  }
}

export class InvalidProportionChartTypeRygQuartileColorError extends InvalidProportionChartTypeRygError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidProportionChartTypeRygQuartileColorError";
  }
}

export class InvalidProportionChartTypeNeutralError extends InvalidProportionChartTypeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidProportionChartTypeNeutralError";
  }
}
